import { AdminType, APIDelete, APIGet, APIPost, APIPut, APIUrl } from "api/protocols";
import { TCustomerType } from "redux/reducers/models/facility";
import { IDepartments, IProduct } from "redux/reducers/models/product";

export interface IDiscount {
  id: number;
  client_id: number;
  title: string;
  application: string;
  value_type: string;
  value: number;
  custom: boolean;
  start_date: Date;
  end_date: Date;
  daily_start_time?: string;
  daily_end_time?: string;
  notes: string;
  tracked?: boolean;
  auto_apply?: boolean;
  repeat_interval?: "weeks";
  repeat_amount?: number;
  schedule_type?: "nth_weekday" | "date_range";
  week_days?: Array<number>;
  products: IProduct[];
  departments?: IDepartments[];
  customer_types?: TCustomerType[];
}

export interface IGetDiscount {
  id?: number;
  application?: string;
}
export interface IPostDiscount {
  title: string;
  value_type: string;
  application: string;
  value: number;
  custom: boolean;
  tracked: boolean;
}
interface IPutDiscount {
  id: number;
  title: string;
  value_type: string;
  application: string;
  value: number;
  custom: boolean;
  tracked: boolean;
}
interface IDeleteDiscount {
  id: number;
}

interface IPostDiscountLine {
  discount_id: number;
  cart_id: number;
  cart_line_item_id?: number;
  value_type?: "percent" | "fixed_amount";
  value?: number;
}
interface IDeleteDiscountLine {
  id: number;
  cart_id: number;
}

//Get Discount
//Retrieve discounts
export async function GetDiscount(params?: IGetDiscount, useGlobalLoader?: boolean) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/discount"), params, useGlobalLoader);
}

//POST Discount
//Create a new discount
export async function PostDiscount(params?: IPostDiscount, useGlobalLoader?: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/discount"), params, useGlobalLoader);
}

//PUT Discount
//Update an existing discount
export async function PutDiscount(params?: IPutDiscount, useGlobalLoader?: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/discount"), params, useGlobalLoader);
}

//DELETE Discount
//Delete a discount
export async function DeleteDiscount(params?: IDeleteDiscount, useGlobalLoader?: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/discount"), params, useGlobalLoader);
}

// POST Order
// Create a new order
export async function PostDiscountLine(params: IPostDiscountLine, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/cart/discount"), params, useGlobalLoader);
}

export async function DeleteDiscountLine(param: IDeleteDiscountLine, useGlobalLoader: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/cart/discount"), param, useGlobalLoader);
}
